import { render, staticRenderFns } from "./AlertDialog.vue?vue&type=template&id=4db8db3e&scoped=true&"
import script from "./AlertDialog.vue?vue&type=script&lang=js&"
export * from "./AlertDialog.vue?vue&type=script&lang=js&"
import style0 from "./AlertDialog.vue?vue&type=style&index=0&id=4db8db3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db8db3e",
  null
  
)

component.options.__file = "AlertDialog.vue"
export default component.exports